<template>
	<div>
		<div class="bj_img_h">
			<div style="margin-top: 20px; margin-bottom: 20px;">
				<div>
					<div style="width: 100%;">
						<img style="width: 100%;border-radius:5px;"
							src="https://img.hsnms.com/20220414/1649946591.jpg" />
					</div>
				</div>
			</div>


			<div class="app-container">
				<div class="the-container">
					<el-tabs stretch="" v-model="usable" :tab-position="tabPosition" @tab-click="handleClick">
						<el-tab-pane v-for="(tab,index) in tabs" :key="index" :name="tab.name" :label="tab.label">
							<div v-show="usable==='1'">

								<div class="span12" style="margin-top: 5px;margin-bottom: 5px;"
									v-for="(item, index) in data_list_a.data"  @click="route1(item.connect)">
									<!--t_10-->
									<div class="row">
										<div class="col-3" style="padding-right:1px;">
											<div style="position:relative;width:100%;">
												<img style="width: 100%; border-radius:3%;"
													:src=item.imgages_a />
											</div>
										</div>
										<div class="col-9">
											<h4>{{item.title}}</h4>
											<h6>{{item.describe}}</h6>
										</div>
									</div>
									<hr />
								</div>
								<el-button class="bin_tijiao_data" type="primary" v-if="data_list_a.v"  @click="list_a">
									更多内容
								</el-button>
								
								
								
								
							</div>
							<div v-show="usable==='2'">
								<el-form ref="form" :model="form" style="font-size: 16px;">

									<div style="margin-bottom: 3rem;">
										<div class="bt_hs1 tiaoti_a" style="margin-bottom: 15px;">请选择需要咨询的类别</div>
										<el-radio-group v-model="form.resource">
											<div style="margin-bottom: 1rem;">
												<el-radio label="劳动纠纷"></el-radio>
											</div>
											<el-radio label="政策详讯"></el-radio>
										</el-radio-group>
									</div>

									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">请输入您的具体问题</div>
										<el-input type="textarea" v-model="form.desc" :rows="4"></el-input>
									</div>

									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">姓名</div>
										<el-input v-model="form.name"></el-input>
									</div>

									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">电话</div>
										<el-input v-model="form.name"></el-input>
									</div>

									<el-form-item style="margin-top: 30px; margin-bottom:20px;">
										<el-button class="bin_tijiao" type="primary" >提交申请</el-button>
									</el-form-item>

								</el-form>

							</div>
							<div v-show="usable==='3'">
								<div class="span12" style="margin-top: 5px;margin-bottom: 5px;"
									v-for="(item, index) in [2]">
									<!--t_10-->
									<div class="row">
										<div class="col-12">
											<h5>我的维权：2022年4月14日</h5>
											<h4 style="line-height: 25px;">工伤怎么赔付，有伤残鉴定</h4>
											<h5>律师回复：2022年4月15日</h5>
											<h4 style="line-height: 25px;">您好，工伤后，如经劳动能力鉴定构成等级，依照不同的等级，有不同的赔付标准。 根据我国工伤保险条例的规定和伤残等级的情况，主要有医疗费、伙食补助费、护理费、一次性伤残补助金、一次性工伤医疗补助金、一次性伤残就业补助金、停工留薪期工资、伤残津贴、交通费、鉴定费等。</h4>
										</div>
								
									</div>
									<hr />
								</div>
							</div>
							<div v-show="usable==='4'">
								<h1>部门管理</h1>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<div style="height: 20px;"></div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data_list_a: {
					data: [],
					page: 1,
					v: false,
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
					name: '1',
					label: '普法宣传'
				}, {
					name: '2',
					label: '申请维权'
				}, {
					name: '3',
					label: '律师回复'
				}]
			}
		},
		mounted() {
			this.list_a()
		},
		methods: {
			route1: function(myurl) {
				window.open(myurl,"_blank");
			},
			route1: function(myurl) {
				
				window.open(myurl,"_blank");
			
					// ZWJSBridge.openLink({
					// 	"url": myurl
					// }).then(res => {
					// 	console.log(res)
					// }).catch(err => {
					// 	console.log(err)
					// })
			},
				list_a() {
					var datas = this.data_list_a;
					this.$api.getAPI("data/info/?type_id=202204005&page=" + datas.page, {
						key_id: this.$route.query.id,
					}).then(res => {
						var lists = res.data.data.data[0].models;
						if (lists.length == 10) {
							datas.v = true;
							this.data_list_a.page = datas.page + 1;
						} else {
							this.data_list_a.v = false;
						}
						for (let i = 0; i < lists.length; i++) {
							this.data_list_a.data.push(lists[i])
						}
					})
				},
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}
	.bin_tijiao {
		height: 50px;
		width: 100%;
		font-size: 16px;
		
		
	}
	.tiaoti_a {
		margin-bottom: .5rem;
		font-size: 16px
	}
	
	.el-tabs__item {
		font-size: 18px !important;
	}
	
	.tiaoti_a_int {
		font-size: 16px;
	}
	
	.el-input__inner {
		padding-left: 10px !important;
		height: 45px !important;
		line-height: 45px !important;
	}
	.header {
		height: 20rem;
		color: #fff;
		background: url(http://www.baiduhrb.com/fjh/images/user_bg.png);
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/pfwq.vue